import ErrorCodeHelper from '@dealroadshow/error-codes';
import { RpcError } from '@dealroadshow/json-rpc-dispatcher';
import Container from '@framework/di/Container';
import isServer from '@framework/router/Next/isServer';
import DataroomErrorHandler from '@dataroom/error-handler';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import {
  SelfDeclarationModalContextSymbol,
  type ISelfDeclarationModalContext,
} from '@dataroom/self-declaration/types';
import type { TDataroomResponseInterceptor } from './types';

export const investorDisclaimerInterceptor = (
  container: Container,
  tenant: DataroomTenant,
): TDataroomResponseInterceptor => (
  async (response) => {
    if (!(response instanceof RpcError)) {
      return response;
    }

    const isPrivateFilesError = response.getCode() === ErrorCodeHelper.getCodeByName('PRIVATE_FILES_ACCESS_NOT_COMPLETED');

    if (!isPrivateFilesError) {
      return response;
    }

    if (isServer()) {
      container.get<DataroomErrorHandler>(DataroomErrorHandler).handleError(response, null, tenant);
      return response;
    }

    const errorData = response.error as unknown as Record<string, unknown>;
    const dataroomId = errorData?.dataroomId as number | undefined;
    const dataroomName = (errorData?.dataroomName || errorData?.dataroomDisplayName) as string | undefined;

    if (dataroomId && dataroomName) {
      const context = container.get<ISelfDeclarationModalContext>(SelfDeclarationModalContextSymbol);

      if (context?.openModal) {
        context.openModal(dataroomId, dataroomName);
      }
    }

    return response;
  }
);
